import { getAuth } from '@firebase/auth';
import { Button } from '@mui/material';
import { applyActionCode, sendEmailVerification } from 'firebase/auth';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { handleError } from '../../../common/firebase/auth-error.service';
import { severity } from '../../../common/models/severity.enum';
import { isProdOrDevEnv } from '../../../environment.enum';
import { ServiceManager } from '../../../services/service-manager';
import styles from './VerifyEmail.module.css';

const VerifyEmail = ({ user, setUser }) => {

    const codeQueryParam = 'oobCode'
    const continueUrlParam = 'continueUrl'
    const [searchParams] = useSearchParams();
    const [showError, setShowError] = useState<boolean>(false)
    const navigate = useNavigate();
    const firstRenderRef = useRef(true);

    const refresh = () => {
        const refreshToken = async () => {
            const auth = getAuth();
            if (auth.currentUser) {
                auth.currentUser.getIdToken(true);
                const token = await auth.currentUser.getIdTokenResult(true);
                setUser({ ...user, token });

                if (token.claims.email_verified) {
                    navigate('/auth/new-user');
                }
            } else {
                navigate('/auth/login');
            }
        }
        refreshToken();
    }

    const handleVerifyEmail = (auth, actionCode, continueUrl, lang) => {
        applyActionCode(auth, actionCode).then(async () => {
            ServiceManager.snackbarService.openSnackbar('Uw email is successvol geverifieerd.', severity.success);
            if (auth.currentUser) {
                await auth.currentUser.getIdToken(true);
                const token = await auth.currentUser.getIdTokenResult();
                const u = { ...user, token };
                setUser(u);
                navigate('/auth/new-user');
            } else {
                ServiceManager.snackbarService.openSnackbar('Uw email is successvol geverifieerd.', severity.success);
                navigate('/auth/login');
            }
        }).catch((err) => {
            setShowError(true);
            handleError(err);
        });
    }

    useEffect(() => {
        if (!isProdOrDevEnv() && firstRenderRef.current) {
            firstRenderRef.current = false;
            return;
        }
        const auth = getAuth();
        const lang = searchParams.get('lang') || 'en'

        handleVerifyEmail(auth, searchParams.get(codeQueryParam), searchParams.get(continueUrlParam), lang);
    }, [searchParams])

    const send = () => {
        const auth = getAuth();
        sendEmailVerification(auth.currentUser).then(() => {
            ServiceManager.snackbarService.openSnackbar(`Uw verificatie e-mail is verstuurd naar ${auth.currentUser.email}.`, severity.success);
        }).catch(error => {
            if (error.message) {
                ServiceManager.snackbarService.openSnackbar('Er is iets misgegaan: ' + error.message, severity.error);
            } else {
                ServiceManager.snackbarService.openSnackbar('Er is iets misgegaan.', severity.error);
            }
        })
    }

    return (
        <div className={styles.VerifyEmail} data-testid="VerifyEmail">
            {showError &&
                <>
                    <p>
                        Deze verificatie code is niet meer geldig. Probeer het nog een keer via onderstaande knop.
                    </p>
                    <Button color="primary" variant="contained" onClick={send}>Opnieuw verzenden</Button>
                    <p>
                        Geverifeerd op andere browser?
                    </p>
                    <Button color="secondary" variant="outlined" onClick={refresh}>Verversen</Button>
                </>
            }
        </div >
    )
};

export default VerifyEmail;
